import { FraudTaskStatusEnum } from "./enums/FraudTaskStatusEnum";
import { Priority } from "./Priority";
import { MonitoringTargetChannelCodeEnum } from "./enums/MonitoringTargetChannelCodeEnum";



export class TaskDetails {
  status: Status
  priority: Priority
  taskId: number
  taskNumber: string
  duedate: Date
  ambassadorData: AmbassadorData
  haveAmbassador: boolean
  trackName: string
  creationDate: Date
  updateDate: Date
  approvalDate: Date
  assignedDate: Date
  requestNumber: string
  canViewRequest: boolean
  requestId: number
  modificationReasons: ModificationReason[]
  group: string
  instructions: string
  canDelete: boolean
  rejectionReason: string
  monitoringTargetChannel: MonitoringTargetChannel
  monitoringTargetName: string
  monitoringTargetValue: string
  fraudType: string
  fraudDetectionForm: string
  institution: string
  escalationReason: string
  complainceRate: number
  publishedTaskName: string
  publishedDate: Date
}

export interface Status {
  title: string
  statusCode: FraudTaskStatusEnum
}

export interface AmbassadorData {
  name: string
  image: string
}
export interface ModificationReason {
  title: string
  reason: string
  date: string
  status: FraudTaskStatusEnum
}
export interface MonitoringTargetChannel {
  id: number
  name: string
  code: string
  icon: MonitoringTargetChannelCodeEnum
}
